

import { useEffect, useState } from "react";

const useCptNamesAndPostsByName = ({ attributes, setAttributes }) => {

  const { updatedCptIds, customTaxonomyPosts, selectedCustomPostType, commaSeparatedIds, RemoveCommaSeparatedIds, selectedLayout } = attributes;
  const [currentSelectedCpt, setCurrentSelectedCpt] = useState("");
  const [data, setData] = useState([]);
  const [restUrl] = useState(aplb_server_data?.rest_url);
  const [isLoading, setIsLoading] = useState(false);
  const [customPostsOptionsResponse, setCustomPostsOptionsResponse] = useState([]);

  useEffect(() => {
    if (commaSeparatedIds.length === 0 && updatedCptIds.length === 0) {
      
      fetchPostsBySelectedCustomPostsType();
    }
  }, [selectedCustomPostType, updatedCptIds, commaSeparatedIds,RemoveCommaSeparatedIds]); 

  //Show Cpt-List on load:
  useEffect(() => {
    fetchCptList();
  }, []); 



  // Change SelectedOption from selectBox:
  const handleSelectedCustomPostType = (value) => {
    setCurrentSelectedCpt(value);
    // Create a copy of customTaxonomyPosts attribute
    const updatedCustomTaxonomyPosts = { ...customTaxonomyPosts };

    // Remove properties related to taxonomy types
    Object.keys(updatedCustomTaxonomyPosts).forEach((item) => {
      delete updatedCustomTaxonomyPosts[item];
    });

    // Update the selected custom post type attribute
    setAttributes({
      ...attributes,
      selectedCustomPostType: value,
      customTaxonomyPosts: updatedCustomTaxonomyPosts,
      updatedCptIds: [], // Set updatedCptIds to an empty array
    });

  };
  const fetchCptList = async () => {

    try {
      const response = await fetch(`${restUrl}wpppro/v1/list-cpt`);

      const customPostsOptionsResponce = await response.json();
      setCustomPostsOptionsResponse(customPostsOptionsResponce);
      // setAttributes({ ...attributes, customPostsOptions: customPostsOptionsResponce });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchPostsBySelectedCustomPostsType = async () => {
    setIsLoading(true); // Set loading to true when starting fetch
    try {

      let post_type = selectedCustomPostType.toLowerCase();
      const separator = restUrl.includes('?') ? '&' : '?';
      let query = `${restUrl}wp/v2/${post_type}${separator}per_page=100`;
      const response = await fetch(query);

      if (!response.ok) {
        throw new Error(
          `Failed to fetch data (${response.status} ${response.statusText})`
        );
      }

      const responseData = await response.json();

      // Ensure responseData is always an array
      const allPostsResponse = Array.isArray(responseData) ? responseData : [responseData];
         if (selectedCustomPostType) {
        setData(allPostsResponse);
        }

     } catch (error) {
      console.error("Error fetching data:", error);
    }finally {
      setIsLoading(false); // Set loading to false once fetch is complete
    }
  };

  //Fetch taxonomy-Posts-Ids by name with dynamic pagination starting from page 1
  const fetchCustomTaxonomyIdsBytermName = async (term, taxonomyType) => {
  const customTaxonomyPosts = "customTaxonomyPosts";
    const perPage = 100; // Define the number of items per page
    let page = 1; // Initialize page number to 1
    let termIds = []; // Initialize an array to hold all token IDs
    const separator = restUrl.includes('?') ? '&' : '?';
    try {
      // Fetch data for the first page
      while (true) {
        const response = await fetch(
          `${restUrl}wp/v2/${taxonomyType}${separator}page=${page}&per_page=${perPage}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch custom taxonomies");
        }
        const responseData = await response.json();

        // Iterate over the response data to find matching term
        for (const TermName of term) {
          const matchedTermName = responseData.find(
            (data) => data.name === TermName
          );
          if (matchedTermName) {
            termIds.push(matchedTermName.id); // Push each token ID to the array
            // setUpdatedIdsState(false);
          } else {
            return; // Return here to stop further execution
          }
        }

        // If termIds are found or there's no more data, exit the loop
        if (termIds.length > 0 || responseData.length < perPage) {
          break;
        }

        // Increment the page number for the next iteration
        page++;
      }

      // Construct the updated ids array with new IDs and taxonomyType
      const updatedIds = updatedCptIds?.filter(
        (item) => item.taxonomyType !== taxonomyType
      ); // Remove existing IDs for the same taxonomyType  

      termIds.forEach((tokenId) => {

        updatedIds.push({ ids: tokenId, taxonomyType });
      });
      // Update the custom taxonomy posts attribute
      const Cpt = {
        ...attributes[customTaxonomyPosts],
        [taxonomyType]: term,
      };
      setAttributes({
        ...attributes,
        [customTaxonomyPosts]: Cpt,
        updatedCptIds: updatedIds,
      });

    } catch (error) {
      console.error("Error fetching custom taxonomy data:", error);
    }
  };

  useEffect(() => {
   if (commaSeparatedIds.length === 0) {
     fetchCustomTaxonomyPostsByIds(updatedCptIds);
    }
  }, [updatedCptIds ,commaSeparatedIds ,RemoveCommaSeparatedIds]);

  const fetchCustomTaxonomyPostsByIds = async (updatedCptIds) => {
    try {
      const uniquePostIds = new Set();

      // Fetch posts for all IDs concurrently
      const fetchPromises = updatedCptIds.map(
        async ({ ids: termIds, taxonomyType }) => {

          let post_type = selectedCustomPostType.toLowerCase();
          const response = await fetch(
            `${restUrl}wp/v2/${post_type}?${taxonomyType}=${termIds}`
          );
          if (!response.ok) {
            throw new Error(
              `Failed to fetch posts for IDs: ${termIdsArray.join(",")}`
            );
          }
          const responseData = await response.json();

          // Filter out posts that are already fetched
          const uniquePosts = responseData.filter(
            (post) => !uniquePostIds.has(post.id)
          );

          // Add the IDs of newly fetched posts to the set
          uniquePosts.forEach((post) => uniquePostIds.add(post.id));
          return uniquePosts;
        }
      );

      // Wait for all fetch requests to complete
      const responseDataArray = await Promise.all(fetchPromises);

      // Merge all fetched data into a single array
      const mergedData = responseDataArray.reduce(
        (acc, data) => acc.concat(data),
        []
      );

      // Filter the merged data to include only posts that match all term
      const filteredData = mergedData.filter((post) => {
        // Check if the post contains all selected custom taxonomies
        const customTaxonomiesMatch = updatedCptIds.every(
          ({ taxonomyType, ids }) => {
            // Ensure post[taxonomyType] is defined before accessing the includes method
            return post[taxonomyType] && post[taxonomyType].includes(ids);
          }
        );
        // Return true if all custom taxonomies match
        return customTaxonomiesMatch;
      });


      // Compare filteredData with current data using JSON.stringify
      if (JSON.stringify(filteredData) !== JSON.stringify(data)) {
        if (filteredData.length > 0) {
          setData(filteredData); // Update state if filteredData is different
        } else {
          setData([]); // Clear data if filteredData is empty
        }
      }
    } catch (error) {
      console.error("Error fetching posts by custom taxonomy:", error);
    }
  };

  const fetchPostsByIds = async () => {
    try {
      // const apiUrl = `${restUrl}wp/v2/posts?include=${commaSeparatedIds}`;
      const apiUrl = `${restUrl}wpppro/v1/get-post-by-id?id=${commaSeparatedIds}`;

      const response = await fetch(apiUrl);
      const jsonData = await response.json();

      // Compare the fetched data with the current data using JSON.stringify
      if (JSON.stringify(jsonData) !== JSON.stringify(data)) {
        setData(jsonData); // Update state with the fetched data if it has changed
      } 
      
    } catch (error) {
      console.error('Error fetching posts by IDs:', error);
    }
  };


  return {
    isLoading,
    data,
    setData,
    fetchCptList,
    fetchCustomTaxonomyIdsBytermName,
    handleSelectedCustomPostType,
    fetchPostsBySelectedCustomPostsType,
    fetchPostsByIds,
    currentSelectedCpt,
    customPostsOptionsResponse,
  };
};

export default useCptNamesAndPostsByName;